import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot", { email });
      setSent(true);
      if (data.dev_reset_url) setDevLink(data.dev_reset_url);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll send you a link to reset it."
      footer={<><Link to="/login" className="font-semibold text-emerald-800 hover:underline">Back to sign in</Link></>}>
      {sent ? (
        <div className="rounded-xl bg-emerald-50 p-6 text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto mb-3 h-10 w-10 text-emerald-700" />
          <p className="text-slate-700">If an account exists for <b>{email}</b>, a reset link has been sent.</p>
          {devLink && <a href={devLink} className="mt-3 inline-block break-all text-sm text-emerald-700 underline" data-testid="dev-reset-link">Dev link: {devLink}</a>}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="w-full rounded-full bg-emerald-800 py-6 text-white hover:bg-emerald-900">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
